import { Link } from "@inertiajs/react"

import { cn } from "@/lib/utils"

const Tabs = {
  idea: "Idea",
  meta: "Meta",
  structure: "Structure",
  text: "Text",
}

export const PromptTabs = ({ active }: { active: string }) => {
  return (
    <div className="flex w-full flex-col items-center justify-center overflow-x-auto">
      <div className="flex gap-2 rounded-full bg-white p-2 text-[15px] leading-4 font-semibold text-gray-500">
        {Object.entries(Tabs).map(([key, title]) => (
          <Link
            data={{ step: key }}
            key={key}
            className={cn("flex px-4 py-2", {
              "order-0 flex-none flex-grow-0 flex-row items-center justify-center rounded-full bg-[#222222] text-white shadow-[0px_4px_4px_-2px_rgba(0,0,0,0.2),0px_2px_16px_-4px_rgba(0,0,0,0.5),inset_-1px_-1px_2px_#000000,inset_1px_1px_2px_rgba(255,255,255,0.25),inset_0px_-4px_4px_rgba(255,255,255,0.1),inset_0px_4px_4px_rgba(0,0,0,0.25)]":
                active === key,
            })}
          >
            {title}
          </Link>
        ))}
      </div>
    </div>
  )
}
